import { render, staticRenderFns } from "./AdminMatchDetailView.vue?vue&type=template&id=f0d6003e&scoped=true"
import script from "./AdminMatchDetailView.vue?vue&type=script&lang=js"
export * from "./AdminMatchDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d6003e",
  null
  
)

export default component.exports